import React, { Component } from 'react';
import { connect } from 'react-redux';
import { modalActions, incomeEventActions, addAccountActions, accountActions, eventActions } from '../../../redux/root-action';
import styled from 'styled-components';
import * as tokens from '@trp-rps-rps-shared-web/rps-shared-web-styles';
import { Input, Dropdown, Button, CollapsibleHedge, RadioButton } from '@trp-rps-rps-shared-web/rps-shared-web-components';
import ReactModalFooter from '../../Modal/ReactModalFooter';
import ReactModalHeader from '../../Modal/ReactModalHeader';
import ReactModalContent from '../../Modal/ReactModalContent';
import { eventModalViews, analyticsTracking, defaultOption, modals, postActions, pensionTypes, frequency } from '../../../utils/constants';
import { getIntegerAmount, isNumeric, keyDown, formatAmountWithoutDollarAndDecimals } from '../../../utils/helpers';
import { FindValueOperator } from 'rxjs/internal/operators/find';

const StyledIntroText = styled.div`
    margin: 22px 0 26px;
    font-family: Nimbus Sans Light;
    font-size: 20px;
    font-weight: 300;
    line-height: 26px;
    letter-spacing: -0.5px;
    color: ${tokens.ColorGrey900};
    @media only screen and (max-width: 767px) {
        font-size: 16px;
        margin-top: 24px;
    }
`;

const StyledBoldText = styled.div`
    font-family: Nimbus Sans Bold;
    font-size: 16px;
    font-weight: bold;
    line-height: 22px;
    color: ${tokens.ColorGrey900};
`;

const StyledFieldContainer = styled.div`
  display: flex;
  @media only screen and (max-width: 767px) {
    width: 100%;
    margin-top: 16px;
    flex-direction: column;
    align-items: flex-start;
    justify-content: center;
  }

  ul {
    max-height: 320px;
    @media only screen and (max-width: 767px) {
      max-height: 240px;
    }
  }
`;

const StyledInputLabel = styled.div`
  color: ${tokens.ColorGrey900};
  font-size: 16px;
  line-height: 22px;
  height: 56px;
  flex: 0 0 182px;
  display: flex;
  align-items: flex-start;
  flex-direction: column;
  justify-content: center;
  @media only screen and (max-width: 767px) {
    height: auto;
    flex: 0;
  }
`;

const StyledInputLabelPension = styled.div`
  color: ${tokens.ColorGrey900};
  height: 48px;
  display: flex;
  min-width: 184px;
  align-items: center;

  @media only screen and (max-width: 767px) {
    height: auto;
    width: auto;
  }
  > div {
    display: flex !important;
    flex-direction: row-reverse;
    width: auto !important;

    > div {
      height: auto;
      flex: 0 1 0;
      margin-right: 24px;
      font-family: Nimbus Sans Light;
      color: ${tokens.ColorGrey900};
    }
    input[type=radio] {
      height: 16px;
      width: 16px;
      padding: 0;

    }
  }
`;

const StyledInputValue = styled.div`
  height: 56px;
  display: flex;
  align-items: flex-start;
  flex-direction: row;
  justify-content: right;

  > div {
    flex: 1 0 0;
    width: auto;
  }

   input[type=checkbox] {
    height: 16px;
    width: 16px;
    border-radius: 4px;
  }
  label {
    font-weight: normal;
    color: ${tokens.ColorGrey600};
    margin-left: -258px;
  }
  @media only screen and (max-width: 767px) {
    justify-content: left;
    height: auto;
    width: 100%;
    > div {
      flex: 0 0 auto;
    }
    
  }
`;

const AgeRangeContainer = styled.div`
  font-family: Nimbus Sans Regular;
  font-size: 16px;
  line-height: 22px;
  display: flex;
  flex-wrap: wrap;
  flex: 1;
  justify-content: space-between;
  margin-top: 8px;
  padding-right: 100px;
  &#future-income-age-container {
    @media only screen and (max-width: 767px) {
      padding-right: 0px !important;
    }
  }
`;

const TextContainer = styled.div`
  margin-top: 12px;
  color: ${tokens.ColorGrey900};
`;

const InputsContainer = styled.div`
  display: flex;
  flex: 1;
  justify-content: right;
  margin-top: 8px;
`;

const LabelContainer = styled.div`
  flex: 0 0 32px;
  margin: 8px -4px 0 0;
  display: inline;
  color: ${tokens.ColorGrey800};

  &#future-income-age-start-label {
    margin: 4px 4px 0 0;
    font-family: Nimbus Sans Regular;
    font-size: 14px;
    line-height: 16px;
    text-align: left;
    color: ${tokens.ColorGrey600};
    @media only screen and (max-width: 767px) {
      flex: 0 0 min-content;
    }
  }
`;

const InputWithMessage = styled.div`
flex: 1;
  > div {
    > div {
      height: 36px;
    }
    input {
      width: 90px !important;
      padding: 0;
      margin: 0 0 0 16px !important;
      @media only screen and (max-width: 767px) {
        height: 40px;
      }
    }
  }
`;


const InputMessage = styled.div`
  font-family: Nimbus Sans Regular;
  font-size: 14px;
  line-height: 18px;
  color: ${tokens.ColorGrey600};
  text-align: center;
  margin-top: 8px;
`;

const LabelMessage = styled.div`
  font-family: 'Nimbus Sans Regular';
  font-size: 14px;
  line-height: 18px;
  font-style: italic;
  color: ${tokens.ColorGrey700};
  margin-top: 8px;
`;

const StyledExpensesFooterText = styled.div`
  font-family: Nimbus Sans Italic;
  font-size: 16px;
  line-height: 22px;
  color: ${tokens.ColorGrey600};
  margin-bottom: 12px;
  @media only screen and (max-width: 767px) {
    margin-top: 32px;
    margin-bottom: 32px;
  }
`;

const StyledDelete = styled.div`
  display: flex;
  flex: 1;
  align-items: center;
  button {
    cursor: pointer;
    padding-left: 0;
    > div {
      font-family: Nimbus Sans Bold;
    }
  }
  img {
    width: 24px;
    height: 24px;
  }
`;

const StyledError = styled.div`
  font-family: Nimbus Sans Regular;
  font-size: 14px;
  line-height: 18px;
  display: block;
  white-space: pre-wrap;
  color: ${tokens.ColorFunctionalRed700};
  margin: 8px 0 16px;
`;

const StyledText = styled.div`
  font-family: 'Nimbus Sans Regular';
  margin: 8px 0px 16px 0px;
  font-size: 14px;
  color: ${tokens.ColorGrey900};
  @media only screen and (max-width: 767px) {
    margin: 8px 0px 0px 0px;
  }
  b {
    font-family: 'Nimbus Sans Bold'
  }
`;

const StyledAmountContainer = styled.div`
  display: flex;
  width: 100%;
  #future-income-age-annuity-pension::placeholder  {
    {
      padding-top: 2px;
    }
  }
  #future-income-amount-annuity-pension::placeholder {
     {
      padding-top: 2px;
    }
  }
  &#future-income-annuity-age-error {
    @media only screen and (max-width: 767px) {
      margin: 8px -180px 16px 1px;
    }
  }
`;


interface MyState {
  incomeType: string,
  incomeName: string,
  incomeAmount: any,
  startAgeRange: any,
  endAgeRange: any,
  incomeTypeError: any,
  duplicateRetirementJobError: any,
  incomeNameError: any,
  amountError: any,
  startAgeError: any,
  endAgeError: any,
  ageErrorMessage: string,
  checkboxClicked: boolean,
  monthlyClicked: boolean,
  lumpSumClicked: boolean,
  amountHelperText: string,
  annuityAndPensionAgeError: boolean,
  annuityAndPensionAgeErrorMessage: string,
  annuityAndPensionAge: any,
  annuityAndPensionAmount: any,
  annuityAndPensionAmountError: boolean,
  annuityAndPensionAmountMessage: string,
  radioClicked: boolean,
  radioError: boolean,
  radioErrorMessage: string,
  resetEndAge: boolean,
  startAge: '',
  endAge: ''
}

class AddFutureIncome extends Component<any, MyState> {
  retStartAgeDefaultVal = 0;

  constructor(props: any) {
    super(props);
    this.state = {
      incomeType: '',
      incomeName: '',
      incomeAmount: '',
      startAgeRange: '',
      endAgeRange: '',
      incomeTypeError: false,
      duplicateRetirementJobError: false,
      incomeNameError: false,
      amountError: false,
      startAgeError: false,
      endAgeError: false,
      ageErrorMessage: '',
      checkboxClicked: false,
      monthlyClicked: false,
      lumpSumClicked: false,
      amountHelperText: 'After-tax annual amount owner expects to receive.',
      annuityAndPensionAgeError: false,
      annuityAndPensionAgeErrorMessage: '',
      annuityAndPensionAmountError: false,
      annuityAndPensionAmountMessage: '',
      annuityAndPensionAmount: '',
      annuityAndPensionAge: '',
      radioClicked: false,
      radioError: false,
      radioErrorMessage: '',
      resetEndAge: false,
      startAge: '',
      endAge: ''
    };
  }

  componentDidMount = () => {
    const { fetchIncomeEvents, retirementStartAge, events: { selectedEvent } } = this.props;
    fetchIncomeEvents();
    
    if (selectedEvent?.isNewEvent) {
      const startAgeInputBox = document.getElementById('future-income-age-input-start-age') as HTMLInputElement;
      if (startAgeInputBox) {
        startAgeInputBox.value = retirementStartAge;
      }
    }

    if (selectedEvent?.isEditableEvent && !selectedEvent?.isNewEvent) {
      if (selectedEvent?.typeName?.includes('Pension') || selectedEvent?.typeName?.includes('Annuity')) {
        const startAgeAPInputBox = document.getElementById('future-income-age-annuity-pension') as HTMLInputElement;
        if (selectedEvent.startNumber && startAgeAPInputBox) {
          startAgeAPInputBox.value = selectedEvent.startNumber;
        } else if (retirementStartAge) {
          startAgeAPInputBox.value = retirementStartAge;
        }

        if (selectedEvent?.typeName.includes('Pension')) {
          let radioFound = false;
          const paymentMethodRadios = document.getElementsByName('displayType');
    
          for (let i = 0; i < paymentMethodRadios.length; i++) {
            const radio = paymentMethodRadios[i] as HTMLInputElement | null;
            
            if (radio != null && selectedEvent.frequency !== 'ANL' && radio.value === selectedEvent.frequency) {
              radio.checked = true;
              radioFound = true;
              this.setState({
                radioClicked: true,
                radioError: false,
              });
              break;
            }
          }
        }
      } else {
        const startAgeInputBox = document.getElementById('future-income-age-input-start-age') as HTMLInputElement;
        if (startAgeInputBox) {
          startAgeInputBox.value = selectedEvent.startNumber;
        }
      }
    }
  };

  showDeleteFutureIncome = () => {
    const { showModal, setCurrentView } = this.props;
    showModal(eventModalViews.DELETE_FUTURE_INCOME);
  };

  handleTypeOptionChange = (option: any) => {
    const { updateEventsData, updateSelectedIncomeEvent, retirementStartAge, events, riScenario } = this.props;
    let hasRetirementJobAlready = false;
    if (option.name.toLowerCase() === 'retirement job') {
      const allEvents = events.tempScenario.events;
      const accountOwner = document.getElementById('future-income-annual-owner-input-selected') as HTMLInputElement | null;
      if (accountOwner != null) {
        const accountOwnerValue = accountOwner?.innerHTML;
        if (accountOwnerValue) {
          let bpId = 0;
          const [firstName, ...lastNameParts] = accountOwnerValue.split(' ');
          const lastName: string = lastNameParts.join(' ');
          const participantProfile = riScenario.participantProfile;
          const spouseProfile = riScenario.spouseProfile;
          if (participantProfile.firstName.toLowerCase() === firstName.toLowerCase() && 
              participantProfile.lastName.toLowerCase() === lastName.toLowerCase()) {
            bpId = participantProfile.bpId;
            const filteredIncomeEvents = allEvents.filter((item: any) => item.bpId === bpId && item.categoryName.toLowerCase() === 'income');
            hasRetirementJobAlready = filteredIncomeEvents?.some((evt: { typeName: any; }) => evt.typeName !== null && (evt.typeName === option.name));
          } else if (spouseProfile.firstName.toLowerCase() === firstName.toLowerCase() && 
              spouseProfile.lastName.toLowerCase() === lastName.toLowerCase()) {
            bpId = spouseProfile.bpId;
            const filteredIncomeEvents = allEvents.filter((item: any) => item.bpId === bpId && item.categoryName.toLowerCase() === 'income');
            hasRetirementJobAlready = filteredIncomeEvents?.some((evt: { typeName: any; }) => evt.typeName !== null && (evt.typeName === option.name));
          }
        } else {
          // There is no spose so scan all events
          hasRetirementJobAlready = allEvents?.some((evt: { typeName: any; }) => evt.typeName !== null && (evt.typeName === option.name));
        }
      } else {
        hasRetirementJobAlready = allEvents?.some((evt: { typeName: any; }) => evt.typeName !== null && (evt.typeName === option.name));
      }

      if (hasRetirementJobAlready) {
        this.setState({
          incomeType: option.name,
          duplicateRetirementJobError: true
        });
      }
    } else {
      this.setState({
        incomeType: option.name,
        duplicateRetirementJobError: false
      });
    }

    updateSelectedIncomeEvent({
      typeName: option.name,
    });

    this.setState({
      amountHelperText: option.name === 'Retirement Job' ? 'Before-tax amount owner expects to earn from a full or part-time job.' : 'After-tax annual amount owner expects to receive.',
      incomeType: option.name,
      incomeTypeError: false
    });
    
    setTimeout(() => {
      const pensionAnnuityStartAgeBox = document.getElementById('future-income-age-annuity-pension') as HTMLInputElement | null;
      if (pensionAnnuityStartAgeBox) {
        pensionAnnuityStartAgeBox.value = retirementStartAge;
      } else {
        const startAgeInputBox = document.getElementById('future-income-age-input-start-age') as HTMLInputElement;
        if (startAgeInputBox) {
          startAgeInputBox.value = retirementStartAge;
        }
      }
    }, 250);
  }

  handleNameChange = (e: any) => {
    const value = e.target.value;
    const allowedChars = /^[a-zA-Z0-9\s'.,-]+$/;
    const { updateEventsData, updateSelectedIncomeEvent } = this.props;
    if (value.match(allowedChars) || value === '') {
      this.setState({
        incomeNameError: false,
        incomeName: e.target.value
      })
      updateSelectedIncomeEvent({
        [e.target.name]: value,
      });
    }
  };

  handleAmountChange = (e: any) => {
    const { updateEventsData, updateSelectedIncomeEvent } = this.props;
    const value = e.target.value;
    const allowedChars = /^[0-9.,\b]+$/;
    if (value.match(allowedChars) || value === '') {
      this.setState({
        amountError: false,
        incomeAmount: getIntegerAmount(e.target.value),
      });
      updateSelectedIncomeEvent({
        [e.target.name]: getIntegerAmount(value),
      });
    }
  };

  handleStartAge = (e: any) => {
    const { updateEventsData, updateSelectedIncomeEvent } = this.props;
    const value = e.target.value;
    const allowedChars = /^[0-9\b]*$/;
    
    if (value.match(allowedChars)) {
      this.setState({
        startAgeError: false,
        startAgeRange: e.target.value,
      });
      
      if (value) {
        updateSelectedIncomeEvent({
          [e.target.name]: parseInt(value)
        });
      }
    } else {
      const remainingVal = e.target.value.substring(0, e.target.value.length - 1);
      e.target.value = remainingVal;
    }
  };

  handleEndAge = (e: any) => {
    const { updateEventsData, updateSelectedIncomeEvent } = this.props;
    const value = e.target.value;
    const allowedChars = /^[0-9\b]+$/;
    if (value.match(allowedChars) || value === '') {
      this.setState({ 
        endAgeRange: e.target.value,
        resetEndAge: false,
      });
      updateSelectedIncomeEvent({
        [e.target.name]: parseInt(value),
      });
    }
  };

  handleAccountHolderOptionChange = (option: any) => {
    const { updateSelectedIncomeEvent } = this.props;
    updateSelectedIncomeEvent({
      accountHolder: option.name,
    });
  };

  onCheckboxClick = () => {
    const {
      updateSelectedIncomeEvent
    } = this.props;
    this.setState({
      checkboxClicked: this.state.checkboxClicked ? false : true,
      resetEndAge: true,
    }, () => {
      updateSelectedIncomeEvent({ frequency: this.state.checkboxClicked ? 'ONET' : 'ANL' });
    });
  }

  handlePensionOptionChange = (option: any) => {
    const { updateSelectedIncomeEvent } = this.props;
    this.setState({
      radioClicked: true,
      radioError: false,
    });
  };

  onMonthlyClick = () => {
    const {
      updateSelectedIncomeEvent
    } = this.props;
    this.setState({
      monthlyClicked: true,
    });
    updateSelectedIncomeEvent({ frequency: 'MLY' });
  };

  onLumpSumClick = () => {
    const {
      updateSelectedIncomeEvent
    } = this.props;
    this.setState({
      monthlyClicked: false,
    });
    updateSelectedIncomeEvent({ frequency: 'ONET' })
  };

  handleChange = (event: any) => {
    const { updateSelectedIncomeEvent } = this.props;
    if (!isNumeric(Number(getIntegerAmount(event.target.value)))) {
      return;
    }
    this.setState({
      annuityAndPensionAge: getIntegerAmount(event.target.value),
      annuityAndPensionAgeError: false
    })

    updateSelectedIncomeEvent({
      [event.target.name]: getIntegerAmount(event.target.value),
    });
  };

  handleStartAgeIncome = (e: any) => {
    const { updateSelectedIncomeEvent } = this.props;
    const value = e.target.value;
    const allowedChars = /^[0-9\b]+$/;
    if (value.match(allowedChars) || value === '') {
      this.setState({ startAge: e.targetValue });
      updateSelectedIncomeEvent({
        [e.target.name]: parseInt(value),
      });
    } else {
      const remainingVal = e.target.value.substring(0, e.target.value.length - 1);
      e.target.value = remainingVal;
    }
  };

  handlePensionAnnuityAmountChange = (event: any) => {
    const { updateSelectedIncomeEvent } = this.props;
    const value = event.target.value;
    if (!isNumeric(Number(getIntegerAmount(event.target.value)))) {
      return;
    }
    const allowedChars = /^[0-9.,\b]+$/;
    if (value.match(allowedChars) || value === '') {
      this.setState({
        annuityAndPensionAmountError: false,
        annuityAndPensionAmount: getIntegerAmount(event.target.value),
      });

      updateSelectedIncomeEvent({
        [event.target.name]: getIntegerAmount(event.target.value),
      });
    };
  }

  getDropdownErrorMessage() {
    if (this.state.incomeTypeError) {
      return 'Please select an Income Type';
    }

    if (this.state.duplicateRetirementJobError) {
      return 'Only one retirement job per owner is allowed.';
    }
  }

  handleCancel = () => {
    const {
      showModal,
      hideModal,
      setCurrentView,
      events: {
        selectedEvent,
        tempScenario,
      },
      updateEventsData,
    } = this.props;
    if (selectedEvent.action === postActions.ADD && selectedEvent.bpId === (null || undefined)) {
      tempScenario?.events.splice(selectedEvent.eventIndex, 1);
    }
    updateEventsData({ events: tempScenario.events });
    setCurrentView(eventModalViews.FUTURE_INCOME_MODAL);
    hideModal();
    showModal(eventModalViews.FUTURE_INCOME_MODAL);
  };

  handleSave = () => {
    const {
      updateEventsData,
      showModal,
      updateSelectedIncomeEvent,
      setCurrentView,
      events,
      account,
      events: { selectedEvent },
      riScenario: { scenarioId, participantProfile, spouseProfile, retirementStartAge, retirementEndAge, spouseRetirementStartAge, spouseRetirementEndAge, birthDate },
      accHolder,
    } = this.props;
    const {
      incomeType,
      incomeName,
      incomeAmount,
      incomeNameError,
      amountError,
      startAgeRange,
      endAgeRange,
      startAgeError,
      endAgeError,
      ageErrorMessage,
      checkboxClicked,
      monthlyClicked,
      lumpSumClicked,
      radioClicked,
      radioError,
    } = this.state;

    const tempEvents = [...events?.tempScenario?.events];
    const {
      name,
      id,
      amount,
      accountHolder,
      error = {},
      selectedEventType = defaultOption,
      expenseOption,
      isNewEvent,
      eventIndex,
      includeInScenario = true,
      startNumber,
      endNumber,
      typeName,
      unit = 'AGE',
      frequency,
      categoryName = 'Income',
    } = selectedEvent;

    //get participant age
    let today = new Date();
    let dob = new Date(birthDate);
    let currentAge = today.getFullYear() - dob.getFullYear();
    let fqcy = '';
    let startAgeValue = 0;
    let endAgeValue = 0;

    if (typeName?.includes('Pension')) {
      const paymentMethodRadios = document.getElementsByName('displayType');

      for (let i = 0; i < paymentMethodRadios.length; i++) {
        const radio = paymentMethodRadios[i] as HTMLInputElement | null;
        if (radio != null && radio.checked) {
          fqcy = radio.value;
        }
      }
    } else if (typeName?.includes('Annuity')) {
      fqcy = 'MLY';
    } else {
      const checkbox = document.getElementById('future-income-one-time-event') as HTMLInputElement;

      if (this.state.checkboxClicked || (checkbox && checkbox.checked)) {
        fqcy = 'ONET';
      } else {
        fqcy = 'ANL';
      }
    }

    tempEvents[eventIndex] = {
      ...selectedEvent,
      action: id ? 'UPDATE' : 'ADD',
      bpId: accountHolder === accHolder ? participantProfile?.bpId : spouseProfile?.bpId,
      scenarioId,
      name: name,
      balance: amount,
      accountHolder: accountHolder,
      typeName: typeName?.includes('Pension') ? fqcy === 'MLY' ? 'Pension – Monthly' : 'Pension – Lump Sum' : typeName,
      age: currentAge,
      unit,
      frequency: fqcy,
      includeInScenario,
      startNumber: startNumber ? startNumber : retirementStartAge,
      endNumber: fqcy === 'ONET' || typeName?.includes('Pension') || typeName === 'Annuity' ? null : endNumber,
      categoryName: typeName?.includes('Pension') ? 'Pension' : categoryName,
      sameAsRetirementAge: startNumber === retirementStartAge && endNumber === retirementEndAge ? 'Yes' : 'No'
    }

    const selectedIncomeType = document.getElementById('future-income-type-dropdown-selected') as HTMLInputElement | null;
    const selectedIncomeTypeValue = selectedIncomeType?.innerHTML;
    const amountInput = document.getElementById('future-income-annual-amount-input') as HTMLInputElement | null;
    const annualAmountValue: any = (amountInput?.value);
    
    if (typeName?.includes('Pension') || typeName?.includes('Annuity')) {
      const startAgeInput = document.getElementById('future-income-age-annuity-pension') as HTMLInputElement | null;
      startAgeValue = Number(startAgeInput?.value);
    } else {
      const startAgeInput = document.getElementById('future-income-age-input-start-age') as HTMLInputElement | null;
      startAgeValue = Number(startAgeInput?.value);
      const endAgeInput = document.getElementById('future-income-age-input-end-age') as HTMLInputElement | null;
      endAgeValue = Number(endAgeInput?.value);
    }
   
    const ageAnnuityPensionInput = document.getElementById('future-income-age-annuity-pension') as HTMLInputElement | null;
    const ageAnnuityPensionValue: number = Number(ageAnnuityPensionInput?.value);
    const amountAnnuityPensionInput = document.getElementById('future-income-amount-annuity-pension') as HTMLInputElement | null;
    const amountAnnuityPensionValue: any = (amountAnnuityPensionInput?.value);

    let checkboxValue = false;
    if (this.state.checkboxClicked ? true : false || fqcy === 'ONET') {
      checkboxValue = true;
    }

    this.setState({
      incomeName: name ? name : '',
      duplicateRetirementJobError: false,
      incomeNameError: false,
      amountError: false,
      startAgeError: false,
      endAgeError: false,
      ageErrorMessage: '',
      annuityAndPensionAgeError: false,
    });

    // console.log('tempEvents ===========> ', tempEvents);
    // console.log('startAgeValue: ', startAgeValue);
    // console.log('endAgeValue: ', endAgeValue);
    // console.log('retirementStartAge: ', retirementStartAge);
    // console.log('retirementEndAge: ', retirementEndAge);
    // console.log('accountHolder: ', accountHolder);
    // console.log('accHolder: ', accHolder);
    // console.log('currentAge: ', currentAge);

    if (selectedIncomeTypeValue === 'Select' || !typeName) {
      //console.log('In 1');
      this.setState({ incomeTypeError: true });
    }
    else if (typeName?.includes('Retirement Job') && this.state.duplicateRetirementJobError) {
      //console.log('In 2');
      this.setState({ duplicateRetirementJobError: true });
    }
    else if (name === '' || !name) {
      //console.log('In 3');
      this.setState({ incomeNameError: true });
    }
    else if (!typeName?.includes('Pension') && typeName !== 'Annuity' && !(getIntegerAmount(annualAmountValue) > 0)) {
      this.setState({ amountError: true });
      //console.log('In 4');
    }
    else if (isNaN(startAgeValue) || startAgeValue === 0) {
      //console.log('In 6');
      if (typeName?.includes('Pension') || typeName?.includes('Annuity')) {
        this.setState({
          annuityAndPensionAgeError: true,
          annuityAndPensionAgeErrorMessage: 'Start age can not be blank.\n'
        })
      } else {
        this.setState({
          startAgeError: true,
          ageErrorMessage: 'Start age can not be blank.\n'
        })
      }
    }
    else if (fqcy !== 'ONET' && accountHolder === accHolder && startAgeValue < getIntegerAmount(retirementStartAge)) {
      this.setState({
        startAgeError: true,
        ageErrorMessage: 'Start age must be ' + retirementStartAge + ' or older.\n'
      })
      //console.log('In 5');
    }
    else if (fqcy !== 'ONET' && !typeName?.includes('Pension') && !typeName?.includes('Annuity') && (isNaN(endAgeValue) || endAgeValue === 0)) {
      this.setState({
        endAgeError: true,
        ageErrorMessage: 'End age can not be blank.\n'
      })
      // console.log('In 6...');
    }
    else if (startAgeValue < 18) {
      //console.log('In 8');
      this.setState({
        startAgeError: true,
        ageErrorMessage: 'Start age must be 18 or older.\n'
      })
    }
    else if (startAgeValue > getIntegerAmount(retirementEndAge)) {
      //console.log('In 9');
      this.setState({
        startAgeError: true,
        ageErrorMessage: 'Start age must be lower than participant retirement end age ' + retirementEndAge + '.\n'
      })
    }
    else if (fqcy !== 'ONET' && (startAgeValue > endAgeValue) && (!typeName?.includes('Pension') && !typeName?.includes('Annuity'))) {
      //console.log('In 10');
      this.setState({
        startAgeError: true,
        endAgeError: true,
        ageErrorMessage: 'Start age must be before end age.\n'
      })
    }
    
    else if (fqcy !== 'ONET' && (startAgeValue >= endAgeValue) && (!typeName?.includes('Pension') && !typeName?.includes('Annuity'))) {
      //console.log('In 11');
      this.setState({
        startAgeError: true,
        endAgeError: true,
        ageErrorMessage: 'Age range must be one year or longer.\n'
      })
    }
    else if (accountHolder === accHolder && fqcy !== 'ONET' && (endAgeValue > getIntegerAmount(retirementEndAge)) && (!typeName?.includes('Pension') && !typeName?.includes('Annuity'))) {
      this.setState({
        endAgeError: true,
        ageErrorMessage: 'End age must be ' + retirementEndAge + ' or younger.\n'
      })
      //console.log('In 12');
    }
    else if (fqcy !== 'ONET' && endAgeValue > 114 && (!typeName?.includes('Pension') && !typeName?.includes('Annuity'))) {
      this.setState({
        endAgeError: true,
        ageErrorMessage: 'End age must be 114 or younger.\n'
      })
      //console.log('In 13');
    }
    else if (ageAnnuityPensionValue < 18) {
      this.setState({
        annuityAndPensionAgeError: true,
        annuityAndPensionAgeErrorMessage: 'Age must be 18 or older.\n'
      })
      //console.log('In 14');
    }
    else if (accountHolder === accHolder && ageAnnuityPensionValue < getIntegerAmount(retirementStartAge)) {
      this.setState({
        annuityAndPensionAgeError: true,
        annuityAndPensionAgeErrorMessage: 'Age must be ' + retirementStartAge + ' or older.\n'
      })
      //console.log('In 15');
    }
    else if (ageAnnuityPensionValue > 114) {
      this.setState({
        annuityAndPensionAgeError: true,
        annuityAndPensionAgeErrorMessage: 'Age must be 114 or younger.\n'
      })
      //console.log('In 16');
    }
    else if (accountHolder === accHolder && ageAnnuityPensionValue > getIntegerAmount(retirementEndAge)) {
      this.setState({
        annuityAndPensionAgeError: true,
        annuityAndPensionAgeErrorMessage: 'Age must be ' + retirementEndAge + ' or younger.\n'
      })
      //console.log('In 17');
    }
    else if ((typeName?.includes('Pension') || typeName === 'Annuity') && !(getIntegerAmount(amountAnnuityPensionValue) > 0)) {
      this.setState({ annuityAndPensionAmountError: true, amountError: false })
      //console.log('In 18');
    }
    else if ((typeName?.includes('Pension') || typeName === 'Annuity') && !isNaN(endAgeValue) && endAgeValue !== 0) {
      if (typeName === 'Pension') {
        if (fqcy === 'MLY') {
          if (accountHolder === accHolder && endAgeValue !== retirementEndAge) {
            this.setState({
              annuityAndPensionAgeError: true,
              annuityAndPensionAgeErrorMessage: 'End age value ' + endAgeValue + ' can not be same as retirement end age\n'
            });
          }
        }
      } /*else { commented out per DE59370
        if (accountHolder === accHolder && endAgeValue !== retirementEndAge) {
          this.setState({
            annuityAndPensionAgeError: true,
            annuityAndPensionAgeErrorMessage: 'End age value ' + endAgeValue + ' can not be same as retirement end age\n'
          });
        }
      }*/
      //console.log('In 19');
    }
    else if (typeName?.includes('Pension') && !radioClicked) {
      this.setState({
        radioError: true,
        radioErrorMessage: 'Please check an option to continue.\n'
      })
      //console.log('In 20');
    }
    else if (accountHolder === accHolder && !(typeName?.includes('Pension') || typeName === 'Annuity') && !endAgeValue && fqcy !== 'ONET') {
      this.setState({
        endAgeError: true,
        ageErrorMessage: 'End age must be ' + retirementEndAge + ' or younger.\n'
      })
      //console.log('In 21');
    }
    else if (accountHolder !== accHolder && startAgeValue < getIntegerAmount(spouseRetirementStartAge)) {
      this.setState({
        startAgeError: true,
        ageErrorMessage: 'Start age must be ' + spouseRetirementStartAge + ' or older.\n'
      })
      //console.log('In 22');
    }
    else if (accountHolder !== accHolder && fqcy !== 'ONET' && (endAgeValue > getIntegerAmount(spouseRetirementEndAge))) {
      this.setState({
        endAgeError: true,
        ageErrorMessage: 'End age must be ' + spouseRetirementEndAge + ' or younger.\n'
      })
      //console.log('In 23');
    }
    else if (accountHolder !== accHolder && fqcy !== 'ONET' && (endAgeValue > getIntegerAmount(spouseRetirementEndAge))) {
      this.setState({
        endAgeError: true,
        ageErrorMessage: 'Spouse retirement end age must be younger than ' + spouseRetirementEndAge + '\n'
      });
      //console.log('In 24');
    }
    else if (accountHolder !== accHolder && ageAnnuityPensionValue < getIntegerAmount(spouseRetirementStartAge)) {
      this.setState({
        annuityAndPensionAgeError: true,
        annuityAndPensionAgeErrorMessage: 'Age must be ' + spouseRetirementStartAge + ' or older.\n'
      })
      //console.log('In 25');
    }
    else if (accountHolder !== accHolder && ageAnnuityPensionValue > getIntegerAmount(spouseRetirementEndAge)) {
      this.setState({
        annuityAndPensionAgeError: true,
        annuityAndPensionAgeErrorMessage: 'Age must be ' + spouseRetirementEndAge + ' or younger.\n'
      })
      //console.log('In 26');
    }
    else if (accountHolder !== accHolder && !(typeName?.includes('Pension') || typeName === 'Annuity') && !endAgeValue && fqcy !== 'ONET') {
      this.setState({
        endAgeError: true,
        ageErrorMessage: 'End age must be ' + spouseRetirementEndAge + ' or younger.\n'
      })
      //console.log('In 27');
    }
    else {
      //console.log('In UPDATE');
      updateEventsData({ events: tempEvents })
      showModal(eventModalViews.FUTURE_INCOME_MODAL);
    }
  };

  render(): JSX.Element {
    const mq = window.matchMedia('(max-width: 767px)');
    const {
      incomeEvents,
      retirementStartAge,
      spouseRetirementStartAge,
      // accountHolderOptions,
      events: { selectedEvent },
      account: { accountHolderOptions },
      accHolder,
    } = this.props;

    // For testing purpose - populate incomeType locally -mac
    const incomeEvents1 = [
      {'id': 1, 'name': 'Annuity', 'value': 'annuity'},
      {'id': 2, 'name': 'Pension', 'value': 'pension'},
      {'id': 3, 'name': 'Major Sale', 'value': 'major-sale'},
      {'id': 4, 'name': 'Inherited Asset', 'value': 'inherited-asset'},
      {'id': 5, 'name': 'Custom', 'value': 'custom'},
      {'id': 6, 'name': 'Rental Income', 'value': 'rental-income'},
      {'id': 7, 'name': 'Retirement Job', 'value': 'retirement-job'},
      {'id': 8, 'name': 'TEST Job', 'value': 'test-job'}
    ];

    const {
      checkboxClicked,
      incomeAmount,
      amountHelperText,
      monthlyClicked,
      lumpSumClicked,
      annuityAndPensionAmount,
      annuityAndPensionAge,
      resetEndAge
    } = this.state;

    const showGlobalError = false;

    const numberInputKeyDown = (event: React.KeyboardEvent<HTMLInputElement>) => {
      const eventCode = event.key.toLowerCase();
      if (!(event.key !== null
        && (eventCode.includes("digit")
          || eventCode.includes("arrow")
          || eventCode.includes("home")
          || eventCode.includes("end")
          || eventCode.includes("backspace")
          || (eventCode.includes("numpad") && eventCode.length === 7)))
      ) {
        event.preventDefault();
      }
    };

    const {
      name,
      balance,
      accountHolder,
      categoryName,
      error = {},
      selectedEventType = defaultOption,
      typeName,
      isNewEvent,
      startNumber,
      endNumber,
      startAge,
      endAge,
      amount,
      sourceValue,
      frequency,
    } = selectedEvent;

    return (
      <React.Fragment>
        <ReactModalHeader
          modalTitle="Future Income"
          showClose={true}
          handleCloseIconClick={this.handleCancel} />
        <ReactModalContent showGlobalError={showGlobalError}>
          <StyledIntroText tabIndex={0} id={'future-expense-event-intro-text'}>
            Once you add a retirement income entry, it will be included in your  projections.
            Please review your information regularly to make sure it's up to date.
          </StyledIntroText>
          <StyledBoldText id={'future-income-event-bold-text'}>All fields are required.</StyledBoldText>
          <StyledFieldContainer>
            <StyledInputLabel id={'future-income-type-label'}>Income Type</StyledInputLabel>
            <Dropdown
              label={typeName ? typeName?.includes('Pension') ? 'Pension' : typeName : "Select"}
              options={incomeEvents}
              onChange={(option: any) => this.handleTypeOptionChange(option)}
              selectedOption={selectedEventType.name}
              name="typeName"
              width={mq.matches ? '100%' : 266}
              errorMessage={this.getDropdownErrorMessage()}
              id={'future-income-type-dropdown'} />
          </StyledFieldContainer>
          <StyledFieldContainer>
            <StyledInputLabel id={'future-income-name-label'}>Income Name</StyledInputLabel>
            <Input
              name="name"
              value={name ? name : ''}
              type="text"
              placeholder="Income Name"
              onChange={this.handleNameChange}
              aria-label="incomeName"
              width={mq.matches ? '100%' : 268}
              errorMessage={this.state.incomeNameError && 'Income Name cannot be blank'}
              id={'future-income-name-input'} />
          </StyledFieldContainer>
          {(!typeName?.includes('Pension') && typeName !== 'Annuity') &&
            <>
              <StyledFieldContainer>
                <StyledInputLabel id={'future-income-annual-amount-label'}>Annual Amount</StyledInputLabel>
                <Input
                  name="amount"
                  value={(incomeAmount || incomeAmount === 0) ? formatAmountWithoutDollarAndDecimals(incomeAmount) : amount ? formatAmountWithoutDollarAndDecimals(amount) : ''}
                  placeholder="Amount"
                  onChange={this.handleAmountChange}
                  autoComplete="off"
                  aria-label="amount"
                  helperText={amountHelperText}
                  errorMessage={this.state.amountError && 'Annual amount must be greater than $0'}
                  width={mq.matches ? '100%' : 268}
                  leadingCharacter="$"
                  maxLength={11}
                  id={'future-income-annual-amount-input'} />
              </StyledFieldContainer>
            </>
          }
          <>
            {accountHolderOptions.length === 1 ? (
              <StyledFieldContainer>
                <StyledInputLabel id={'future-income-annual-owner-label'}>Owner </StyledInputLabel>
                <StyledInputValue>
                  <Input
                    value={accountHolder ? accountHolder : accHolder}
                    name="accountHolder"
                    autoComplete="off"
                    aria-label="owner"
                    width={mq.matches ? '100%' : 268}
                    errorMessage={''}
                    className="blocked_data"
                    id={'future-income-annual-owner-input'}
                    readOnly
                    disabled />
                </StyledInputValue>
              </StyledFieldContainer>
            ) : (
              <StyledFieldContainer>
                <StyledInputLabel id={'future-income-annual-owner-label'}>Owner </StyledInputLabel>
                <StyledInputValue>
                  <Dropdown
                    label="Select"
                    textColor={'#3b4b59'}
                    options={accountHolderOptions}
                    onChange={(option: any) => this.handleAccountHolderOptionChange(option)}
                    selectedOption={accountHolderOptions.find((option: any) => option.name === accountHolder) || defaultOption}
                    name="accountHolderOption"
                    width={mq.matches ? '100%' : 268}
                    errorMessage={''}
                    className="blocked_data"
                    id={'future-income-annual-owner-input'} />
                </StyledInputValue>
              </StyledFieldContainer>
            )}
          </>
          {(typeName?.includes('Pension') || typeName === 'Annuity') &&
            <>
              <StyledFieldContainer>
                <StyledInputLabel style={{ height: mq.matches ? 'auto' : 40, color: '#2d3940' }}>Payment Method</StyledInputLabel>
                {typeName === 'Annuity' ?
                  (<StyledInputValue style={{ height: 'auto', paddingTop: '8px', color: '#2d3940' }}>
                    Monthly
                  </StyledInputValue>)
                  :
                  (
                    <StyledInputLabelPension>
                      <Input
                        name="displayType"
                        label="Monthly"
                        type="radio"
                        value="MLY"
                        onChange={(option: any) => this.handlePensionOptionChange(option)}
                        onClick={this.onMonthlyClick}
                        checked={frequency === 'MLY'}
                      ></Input>
                      <Input
                        name="displayType"
                        label="Lump&nbsp;Sum"
                        type="radio"
                        value="ONET"
                        onChange={(option: any) => this.handlePensionOptionChange(option)}
                        onClick={this.onLumpSumClick}
                        checked={frequency === 'ONET'}
                      ></Input>
                    </StyledInputLabelPension>
                  )
                }
              </StyledFieldContainer>              
                <>
                  {typeName === 'Annuity' && (
                    <StyledFieldContainer>
                      <StyledInputLabel style={{height: 0}}></StyledInputLabel>
                      <StyledText tabIndex={0} style={{ marginTop: 0 }}>Annuities will not be added to your total savings balance. They will be displayed in the <b>Retirement Income Over Time</b> chart.</StyledText>
                    </StyledFieldContainer>
                  )}
                  {frequency === 'MLY' && (
                    <StyledFieldContainer>
                      <StyledInputLabel style={{height: 0}}></StyledInputLabel>
                      <StyledText tabIndex={0} style={{ marginTop: 0 }}>Monthly pensions will not be added to your total savings balance. They will be displayed in the <b>Retirement Income Over Time</b> chart.</StyledText>
                    </StyledFieldContainer>
                  )}
                  {frequency === 'ONET' && (
                    <StyledFieldContainer>
                      <StyledInputLabel style={{height: 0}}></StyledInputLabel>
                      <StyledText tabIndex={0} style={{ marginTop: 0 }}>Lump Sum payment is a one-time distribution from your defined benefit pension plan.{' '}</StyledText>
                    </StyledFieldContainer>
                  )}
                  {(typeName?.includes('Pension')) && this.state.radioError && (
                    <StyledFieldContainer>
                      <StyledInputLabel style={{height: 0}}></StyledInputLabel>
                      <StyledError id={`future-income-radio-error`}>{this.state.radioErrorMessage}</StyledError>
                    </StyledFieldContainer>
                  )}
                </>              
              <StyledFieldContainer>
                <StyledInputLabel style={{ height: mq.matches ? 'auto' : 40, color: '#2d3940' }}>Start Age and Amount</StyledInputLabel>
                <StyledAmountContainer>
                  <Input
                    name="startNumber"
                    // value={startNumber ? startNumber : retirementStartAge}
                    placeholder={retirementStartAge}
                    // onChange={this.handleChange}
                    onInput={this.handleStartAgeIncome}
                    autoComplete="off"
                    style={{ marginRight: 16 }}
                    aria-label="Starts At"
                    width={mq.matches ? '80px' : '60px'}
                    id={`future-income-age-annuity-pension`}
                    errorMessage={this.state.annuityAndPensionAgeError && <StyledError id={`future-income-annuity-age-error`}>{this.state.annuityAndPensionAgeErrorMessage}</StyledError>}
                  />
                  <Input
                    name="amount"
                    value={(annuityAndPensionAmount || annuityAndPensionAmount === 0) ? formatAmountWithoutDollarAndDecimals(annuityAndPensionAmount) : amount ? formatAmountWithoutDollarAndDecimals(amount) : ''}
                    placeholder={'Amount'}
                    leadingCharacter="$"
                    trailingCharacter={frequency === 'MLY' || typeName === 'Annuity' ? '/mo.' : '' }
                    onChange={this.handlePensionAnnuityAmountChange}
                    autoComplete="off"
                    aria-label="Amount"
                    width={mq.matches ? '100%' : 176}
                    errorMessage={this.state.annuityAndPensionAmountError && 'Annual amount must be greater than $0'}
                    marginLeftPx={16}
                    id={`future-income-amount-annuity-pension`}
                  />
                </StyledAmountContainer>
              </StyledFieldContainer>
              <StyledFieldContainer style={{ marginBottom: '16px' }}>
                <StyledInputLabel style={{ height: mq.matches ? 'auto' : 40 }}></StyledInputLabel>
                <StyledText tabIndex={0} style={{ marginTop: mq.matches ? '-20px' : 0 }}>
                  Before-tax amount owner expects to receive. We assume  payments will continue throughout retirement.
                </StyledText>
              </StyledFieldContainer>
            </>
          }
          {(!typeName?.includes('Pension') && typeName !== 'Annuity') &&
            <>
              <StyledFieldContainer>
                <StyledInputLabel id={'future-income-annual-owner-age-label'}>Owner's Age</StyledInputLabel>
                <AgeRangeContainer id={`future-income-age-container`}>
                  <LabelContainer id={`future-income-age-start-label`}>{'Start Age'}</LabelContainer>
                  <InputWithMessage id={`future-income-start-age-input`}>
                    <Input
                      name="startNumber"
                      placeholder={'Age'}
                      // placeholder={accountHolder !== accHolder ? spouseRetirementStartAge : retirementStartAge}
                      // value={startNumber ? startNumber : accountHolder !== accHolder ? spouseRetirementStartAge : retirementStartAge}
                      onInput={this.handleStartAgeIncome}
                      width={90}
                      maxLength={3}
                      hasError={this.state.startAgeError}
                      textAlign={'center'}
                      id={`future-income-age-input-start-age`} />
                  </InputWithMessage>
                  <LabelContainer id={`future-income-age-end-label`} style={{ paddingLeft: '20px' }}>
                    <b>{'to'}</b>
                  </LabelContainer>
                  <InputWithMessage id={`future-income-end-age-input`}>
                    <Input
                      name="endNumber"
                      placeholder="Age"
                      //value={frequency === 'ONET' ? endNumber ? endNumber : '' : null}
                      value={resetEndAge ? '' : endNumber ? frequency === 'ONET' ? '' : endNumber : ''}
                      onChange={this.handleEndAge}
                      width={90}
                      maxLength={3}
                      textAlign={'center'}
                      hasError={this.state.endAgeError}
                      style={{ marginRight: 0 }}
                      id={`future-income-age-input-end-age`}
                      disabled={frequency === 'ONET'} />
                  </InputWithMessage>
                  
                </AgeRangeContainer>
              </StyledFieldContainer>
              {(this.state.startAgeError || this.state.endAgeError) && <StyledError id={`future-income-age-error`} style={{marginLeft: mq.matches ? 'auto' : '182px', marginTop: mq.matches ? '8px' : '0'}}>{this.state.ageErrorMessage}</StyledError>}
              <StyledFieldContainer>
                <StyledInputLabel></StyledInputLabel>
                <StyledInputValue>
                  <Input
                    type="checkbox"
                    name={'future-income-one-time-event'}
                    id={'future-income-one-time-event'}
                    onClick={this.onCheckboxClick}
                    checked={frequency === 'ONET'}
                  />
                  <label htmlFor="future-income-one-time-event" id={'future-income-one-time-event-label'}>One-time event</label>
                </StyledInputValue>
              </StyledFieldContainer>
            </>
          }
          <StyledExpensesFooterText id={`future-income-footer-text`}>
            Future income and expense entries are for retirement years. If you set the entry start or end age outside of the owner’s retirement ages, we will only project the years within the retirement age range.
          </StyledExpensesFooterText>
        </ReactModalContent>
        <ReactModalFooter CTAButtonText="Save"
          CTAButtonId={analyticsTracking.RIXFutureIncomeModalActionSave}
          hideCancel={true}
          handleCTAClick={this.handleSave}>
          {!isNewEvent && (<StyledDelete>
            <Button
              type="textButton"
              title="Delete Income"
              fitContainerWidth={mq.matches ? true : false}
              icon={tokens.AssetIconDeleteOutline}
              marginLeftPx={0}
              tabIndex={0}
              id={analyticsTracking.RIXFutureIncomeModalActionDelete}
              onClick={this.showDeleteFutureIncome} />
          </StyledDelete>)}
          {!mq.matches && (
          <Button
            type="textButton"
            title="Cancel"
            marginRightPx={16}
            onClick={this.handleCancel}
            tabIndex={0}
            onKeyPress={(e: React.KeyboardEvent<HTMLDivElement>) => keyDown(e, this.handleCancel)}
            id={analyticsTracking.RIXFutureIncomeModalActionCancel} />
          )}
        </ReactModalFooter>
      </React.Fragment>
    )
  }

}

const mapStateToProps = ({ incomeEvents, account, events, riScenario }: any) => ({
  incomeEvents: incomeEvents.data,
  events,
  account,
  riScenario,
  accHolder: riScenario?.participantProfile?.firstName + ' ' + riScenario?.participantProfile?.lastName,
  birthDate: riScenario.participantProfile.birthDate,
  retirementStartAge: riScenario.retirementStartAge,
  retirementEndAge: riScenario.retirementEndAge,
  spouseRetirementStartAge: riScenario.spouseRetirementStartAge,
  spouseRetirementEndAge: riScenario.spouseRetirementEndAge,
});

export default connect(mapStateToProps, {
  showModal: modalActions.showModal,
  hideModal: modalActions.hideModal,
  setCurrentView: eventActions.setCurrentView,
  fetchIncomeEvents: incomeEventActions.fetchIncomeEvents,
  updateEventsData: eventActions.updateIncomeEventData,
  updateSelectedIncomeEvent: eventActions.updateSelectedIncomeEvent,
})(AddFutureIncome);
